import { EdgeModel } from '@common/models';
import type { RootState } from '@redux/store';
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface EdgeState {
    isApplySameEdgeActive: boolean;
    userSelectedEdge?: EdgeModel;
}

const initialState: EdgeState = {
    isApplySameEdgeActive: true,
};

const edgeSlice = createSlice({
    name: 'edge',
    initialState,
    reducers: {
        updateApplySameEdge: (state, action: PayloadAction<boolean>) => {
            state.isApplySameEdgeActive = action.payload;
        },
        updateUserSelectedEdge: (state, action: PayloadAction<EdgeModel | undefined>) => {
            state.userSelectedEdge = action.payload;
        },
        resetSelectedEdge: (state) => {
            state.userSelectedEdge = undefined;
        },
    },
});

export const { updateApplySameEdge, updateUserSelectedEdge, resetSelectedEdge } = edgeSlice.actions;

export const selectApplySameEdge = ({ edge }: RootState): boolean => edge.isApplySameEdgeActive;

export const selectUserSelectedEdge = ({ edge }: RootState): EdgeModel | undefined => edge.userSelectedEdge;

export default edgeSlice.reducer;
